import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const Container = styled.div`
  margin: auto;
  text-align: center;
  padding-top: 120px;
  color: ${props => props.theme.colors.mutedText};
  height: 100vh;
  ${props =>
    props.borderLeft &&
    css`
      border-left: 1px solid ${props.theme.colors.border};
    `};
`;

export const Header = styled.h1`
  font-size: 36px;
  line-height: 45px;
  margin: auto ${props => props.theme.gutter};
`;

export const Body = styled.h4`
  font-size: 24px;
  line-height: 30px;
  font-weight: normal;
`;
